import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

type StepSelectorProps = {
  headerColor?: string;
  Header: React.ReactNode;
  Body: React.ReactNode;
};

const StepSelector: React.FC<StepSelectorProps> = ({
  headerColor = 'primary.light',
  Header,
  Body,
}) => {
  return (
    <Stack direction="row" borderRadius={2} overflow="hidden" bgcolor="white">
      <Box bgcolor={headerColor} pl={4} pr={6} alignContent="center" minWidth={150}>
        {Header}
      </Box>

      <Stack
        direction="row"
        spacing={4}
        px={4}
        py={3}
        alignContent="center"
        justifyContent="space-between"
      >
        {Body}
      </Stack>
    </Stack>
  );
};

export default StepSelector;
